import { Ingredient } from "../../Types";

export const roundTwoDecimalPlaces = (number: number) =>
    Math.round(number * 100) / 100;

const conversions = [
  { metric: "tbsp", imperial: "tbsp", metricToImperial: 1 },
  { metric: "tsp", imperial: "tsp", metricToImperial: 1 },
  { metric: "taste", imperial: "taste", metricToImperial: 1 },
  { metric: "kg", imperial: "lb", metricToImperial: 2.20462 },
  { metric: "g", imperial: "oz", metricToImperial: 0.035274 },
  { metric: "l", imperial: "cup", metricToImperial: 4.22675 },
  { metric: "ml", imperial: "cup", metricToImperial: 0.00422675 },
  { metric: "ml", imperial: "fl oz", metricToImperial: 0.03519506 },
];

export type MetricUnit = (typeof conversions)[number]["metric"];

export type ImperialUnit = (typeof conversions)[number]["imperial"]

export const convertIngredientToImperial = (ingredient: Ingredient) => {
  const currentConversion = conversions.find(
    (conv) => conv.metric === ingredient.unit
  ) || { imperial: ingredient.unit, metricToImperial: 1 };
  return {
    ...ingredient,
    amount: roundTwoDecimalPlaces(currentConversion.metricToImperial * ingredient.amount),
    unit: currentConversion.imperial,
  };
};